const captureException = (
  ...args: Parameters<typeof Sentry.captureException>
) => {
  if (typeof Sentry !== 'undefined') {
    Sentry.captureException(...args)
  }
}

export default captureException
